import { default as CoeRSLM8EiIrHMeta } from "/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Create/Coe.vue?macro=true";
import { default as EnvironmentalSoundic04b4Xlk6Meta } from "/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Create/EnvironmentalSound.vue?macro=true";
import { default as Pointsc3WOlFKyXOMeta } from "/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Create/Points.vue?macro=true";
import { default as RecordTestTVcn8g8uBfMeta } from "/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Create/RecordTest.vue?macro=true";
import { default as Text8NkdUyE9uWMeta } from "/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Create/Text.vue?macro=true";
import { default as FaqJEoLcQ2RPAMeta } from "/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Faq.vue?macro=true";
import { default as SigninOuTKtb4ItgMeta } from "/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Signin.vue?macro=true";
import { default as indexUuCofX4KDgMeta } from "/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/index.vue?macro=true";
export default [
  {
    name: CoeRSLM8EiIrHMeta?.name ?? "Create-Coe",
    path: CoeRSLM8EiIrHMeta?.path ?? "/Create/Coe",
    meta: CoeRSLM8EiIrHMeta || {},
    alias: CoeRSLM8EiIrHMeta?.alias || [],
    redirect: CoeRSLM8EiIrHMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Create/Coe.vue").then(m => m.default || m)
  },
  {
    name: EnvironmentalSoundic04b4Xlk6Meta?.name ?? "Create-EnvironmentalSound",
    path: EnvironmentalSoundic04b4Xlk6Meta?.path ?? "/Create/EnvironmentalSound",
    meta: EnvironmentalSoundic04b4Xlk6Meta || {},
    alias: EnvironmentalSoundic04b4Xlk6Meta?.alias || [],
    redirect: EnvironmentalSoundic04b4Xlk6Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Create/EnvironmentalSound.vue").then(m => m.default || m)
  },
  {
    name: Pointsc3WOlFKyXOMeta?.name ?? "Create-Points",
    path: Pointsc3WOlFKyXOMeta?.path ?? "/Create/Points",
    meta: Pointsc3WOlFKyXOMeta || {},
    alias: Pointsc3WOlFKyXOMeta?.alias || [],
    redirect: Pointsc3WOlFKyXOMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Create/Points.vue").then(m => m.default || m)
  },
  {
    name: RecordTestTVcn8g8uBfMeta?.name ?? "Create-RecordTest",
    path: RecordTestTVcn8g8uBfMeta?.path ?? "/Create/RecordTest",
    meta: RecordTestTVcn8g8uBfMeta || {},
    alias: RecordTestTVcn8g8uBfMeta?.alias || [],
    redirect: RecordTestTVcn8g8uBfMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Create/RecordTest.vue").then(m => m.default || m)
  },
  {
    name: Text8NkdUyE9uWMeta?.name ?? "Create-Text",
    path: Text8NkdUyE9uWMeta?.path ?? "/Create/Text",
    meta: Text8NkdUyE9uWMeta || {},
    alias: Text8NkdUyE9uWMeta?.alias || [],
    redirect: Text8NkdUyE9uWMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Create/Text.vue").then(m => m.default || m)
  },
  {
    name: FaqJEoLcQ2RPAMeta?.name ?? "Faq",
    path: FaqJEoLcQ2RPAMeta?.path ?? "/Faq",
    meta: FaqJEoLcQ2RPAMeta || {},
    alias: FaqJEoLcQ2RPAMeta?.alias || [],
    redirect: FaqJEoLcQ2RPAMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Faq.vue").then(m => m.default || m)
  },
  {
    name: SigninOuTKtb4ItgMeta?.name ?? "Signin",
    path: SigninOuTKtb4ItgMeta?.path ?? "/Signin",
    meta: SigninOuTKtb4ItgMeta || {},
    alias: SigninOuTKtb4ItgMeta?.alias || [],
    redirect: SigninOuTKtb4ItgMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/Signin.vue").then(m => m.default || m)
  },
  {
    name: indexUuCofX4KDgMeta?.name ?? "index",
    path: indexUuCofX4KDgMeta?.path ?? "/",
    meta: indexUuCofX4KDgMeta || {},
    alias: indexUuCofX4KDgMeta?.alias || [],
    redirect: indexUuCofX4KDgMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/pages/index.vue").then(m => m.default || m)
  }
]